import { render, staticRenderFns } from "./policy-holder-form.vue?vue&type=template&id=38ded87c&scoped=true&"
import script from "./policy-holder-form.vue?vue&type=script&lang=js&"
export * from "./policy-holder-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-holder-form.vue?vue&type=style&index=0&id=38ded87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ded87c",
  null
  
)

export default component.exports